export default class RobotCheckpointModel {
    constructor (checkpointId, direction, startDate, endDate){
        this.checkpointId=checkpointId;
        this.direction=direction;
        this.startDate=startDate;
        this.endDate=endDate;
    }
}